/**
 * Returns button color based on the provided status.
 * @param maintenance_status - used to determine the button color
 * @returns The Material-UI colors: 'primary' or 'secondary'
 */
export const getButtonColor = (maintenance_status: number): 'primary' | 'inherit' => {
  return maintenance_status === 0 ? 'primary' : 'inherit';
};

/**
 * Returns button text based on the provided status.
 * @param device_status - used to determine the button text
 * @param maintenance_status - used to determine the button text
 * @returns The button text string
 */
export const getButtonText = (device_status: number, maintenance_status: number): string => {
  if (maintenance_status === 1) return 'maintenance';
  return device_status === 1 ? 'up' : 'down';
};
